import { useEffect } from "react";

function GithubCallbackPage()
{
    useEffect(() =>
    {
        const params = new URLSearchParams(window.location.search);
        const payload = {
            source: "namirasoft-github-oauth",
            code: params.get("code"),
            state: params.get("state"),
            error: params.get("error"),
            error_description: params.get("error_description"),
        };
        if (window.opener)
        {
            try { window.opener.postMessage(payload, window.location.origin); } catch { }
            setTimeout(() => { try { window.close(); } catch { } }, 200);
        }
    }, []);

    return (
        <div style={{ fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif", padding: "2rem", color: "#333" }}>
            <p>{window.opener ? "You can close this window." : "This page must be opened from the sign in flow."}</p>
        </div>
    );
}

export default GithubCallbackPage;